import { HttpCodes } from '@hotmart/space-lib/dist/constants';
import { QueryClient } from '@tanstack/react-query';

import type { ApiError } from './';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const maxRetries = 2;
        const statusCode = (error as ApiError).statusCode;

        return (
          (statusCode < HttpCodes.BAD_REQUEST || statusCode >= HttpCodes.INTERNAL_SERVER_ERROR) &&
          failureCount <= maxRetries
        );
      }
    }
  }
});

export default queryClient;
